import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FunctionPipe, TranslateTokenisedStringPipe } from '@wdx/shared/utils';
import { MoleculeInputLookupModule } from '../../../components/molecules/molecule-input-lookup/molecule-input-lookup.module';
import { MoleculeActionButtonModule } from '../../molecules/molecule-action-button/molecule-action-button.module';
import { MoleculeOpportunityCardModule } from '../../molecules/molecule-opportunity-card/molecule-opportunity-card.module';
import { OrganismCardsListModule } from '../organism-cards-list/organism-cards-list.module';
import { OrganismOpportunitiesListComponent } from './organism-opportunities-list.component';

@NgModule({
    imports: [
        CommonModule,
        MoleculeActionButtonModule,
        MoleculeInputLookupModule,
        MoleculeOpportunityCardModule,
        OrganismCardsListModule,
        FunctionPipe,
        TranslateTokenisedStringPipe,
    ],
    declarations: [OrganismOpportunitiesListComponent],
    exports: [OrganismOpportunitiesListComponent],
})
export class OrganismOpportunitiesListModule {}
